<template>
  <v-stepper-content step="1" class="pb-0">
    <v-alert v-if="timeLeft == 0 && $store.getters['game/timer']"  class="animated bounceIn" type="error">{{$t('general.timerMessage')}}</v-alert>
    <v-sheet
      v-if="!ddStep"
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$t('steps.clientOrderTitleMessage')}}</v-sheet>
    <v-card class="pa-4" outlined v-if="!ddStep" :class="{'test-mode' : $store.getters['game/test']}">
      <v-row align="center">
        <v-col cols="2" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <company-logo
                :name="$store.getters['company/name']"
                :logo="filesUrl + 'logo/' + $store.getters['company/companySettings'].logo"
              ></company-logo>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" align="center" class="animated bounceIn">
          <v-row>
            <v-col cols="12" align="center">
              <img width="100%" src="@/assets/icon/commande client.png" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" align="center" class="animated bounceInRight delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" align="center" class="animated bounceInRight delay-1s">
          <v-row
            align="center"
            v-for="client in $store.getters['company/data'].clients"
            :key="client._id"
          >
            <v-col cols="6">
              <span
                style="font-size: 28px"
              >{{$tc('general.units', client.requests[client.requests.length - 1], {nbr: client.requests[client.requests.length - 1]})}}</span>
            </v-col>
            <v-col cols="6" align="right">
              <company-logo
                :name="client.client.name"
                :logo="filesUrl + 'logo/' + client.client.companieSettings.logo"
              ></company-logo>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row v-if="!ddStep">
      <v-col cols="12" align="center">
        <v-btn
          class="animated bounceIn delay-2s"
          color="primary"
          :loading="$store.state.company.loading"
          :disabled="$store.state.company.loading"
          @click="validate"
        >{{$t('general.ok')}}</v-btn>
      </v-col>
    </v-row>
    <v-sheet
      v-if="ddStep"
      class="text-center mb-1 card-title animated bounceIn"
      color="primary"
      elevation="1"
      dark
    >{{$t('steps.flowEquationCalc')}}</v-sheet>
    <v-card class="pa-4 animated bounceIn" outlined  v-if="ddStep">
        <v-card-text>
          <v-form ref="flowEquationForm" @submit="false">

          <v-row>
            <v-col cols="12" align="center">
              <v-text-field
                class="inline-block"
                outlined
                width="50px"
                type="number"
                v-model.number="flowEquation"
                :label="$t('stats.flowEquation')"
                validate-on-blur
                readonly
              ></v-text-field>
              <span class="equation">=</span> 
              <v-text-field
                class="inline-block"
                outlined
                width="50px"
                type="number"
                v-model.number="stock"
                :rules="[v => v === stockExpected || $t('general.wrongValue')]"
                :label="$t('dd.availableStock')"
                validate-on-blur
              ></v-text-field>
              <span class="equation">+</span> 
              <v-text-field
                class="inline-block"
                outlined
                width="50px"
                type="number"
                v-model.number="suppliersRemains"
                :label="$t('dd.suppliersRemains')"
                validate-on-blur
                :rules="[v => v === suppliersRemainsExpected || $t('general.wrongValue')]"
              ></v-text-field>
              <span class="equation">-</span> 
              <v-text-field
                class="inline-block"
                outlined
                width="50px"
                type="number"
                v-model.number="clientsRemains"
                :rules="[v => v === clientsRemainsExpected || $t('general.wrongValue')]"
                :label="$t('dd.clientsRemains')"
                validate-on-blur
              ></v-text-field>
            </v-col>
          </v-row>
          </v-form>
        </v-card-text>
        
      </v-card>
      <v-row v-if="ddStep" class="animated bounceIn delay-1s">
        <v-col cols="12" align="center">
          <v-btn
            class="animated bounceIn delay-2s"
            color="primary"
            :loading="$store.state.company.loading"
            :disabled="$store.state.company.loading"
            @click="valideFlowEquation(flowEquation)"
          >{{$t('general.ok')}}</v-btn>
        </v-col>
      </v-row>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import CompanyLogo from "@/components/CompanyLogo";
export default {
  name: "ClientsRequests",
  components: {
    CompanyLogo
  },
  props: {
    step: Number,
    timeLeft: Number
  },
  data: () => ({
    ddStep: false,
    stock: 0,
    clientsRemains: 0,
    suppliersRemains: 0
  }),
  methods: {
    validate() {
      if (this.$store.getters['company/ddOn']) {
        if (this.$store.getters['company/flowEquationDisplay'] == 0) {
          this.valideFlowEquation(this.flowEquationExpected)
        } else if (this.$store.getters['company/flowEquationDisplay'] == 1) {
          this.stock = this.stockExpected
          this.clientsRemains = this.clientsRemainsExpected
          this.suppliersRemains = this.suppliersRemainsExpected
          this.ddStep = true
        } else {
          this.ddStep = true
        }
      } else {
        this.$store.dispatch('company/setStep', 2)
      }
    },
    async valideFlowEquation(flowEquation) {
      if (this.$store.getters['company/flowEquationDisplay'] == 0 || this.$refs.flowEquationForm.validate()) {
        if (await this.$store.dispatch('company/setFlowEquation', {
          flowEquation: flowEquation
        })) {
          this.ddStep = false
        }
      }
    }
  },
  computed: {
    stockExpected () {
      return this.$store.getters['company/data'].dd.flowEquation.availableStock
    },
    clientsRemainsExpected () {
      return this.$store.getters['company/data'].dd.flowEquation.clientsRemains
    },
    suppliersRemainsExpected () {
      return this.$store.getters['company/data'].dd.flowEquation.suppliersRemains
    },
    flowEquationExpected () {
      return this.$store.getters['company/data'].dd.flowEquation.flowEquation
    },
    flowEquation () {
      return this.stock - this.clientsRemains + this.suppliersRemains 
    },
    
    ...mapGetters("company", {
      filesUrl: "filesUrl"
    })
  }
};
</script>
<style>
.inline-block {
  display: inline-block !important;
}
.equation {
  font-size: 24px;
  padding: 15px;
  font-weight: 900;
  display: inline-block;
}
</style>